import { useEffect, useState, useRef } from "react";
import { RECONNECT_INTERVAL, WEB_SOCKET_URL } from "../Utils/config";

// const SERVER_URL = "ws://localhost:5002";
const SERVER_URL = WEB_SOCKET_URL;

export function useWebSocket() {
    const [messages, setMessages] = useState<string[]>([]);
    const [isConnected, setIsConnected] = useState(false);
    const ws = useRef<WebSocket | null>(null);

    const connectWebSocket = () => {
        if (ws.current && ws.current.readyState === WebSocket.OPEN) {
            console.log("WebSocket already connected. Skipping reconnection.");
            return;
        }

        console.log("Connecting to WebSocket server...");

        // Ensure old connection is closed before creating a new one
        if (ws.current) {
            ws.current.close();
        }

        ws.current = new WebSocket(SERVER_URL);

        ws.current.onopen = () => {
            console.log("Connected to WebSocket server");
            setIsConnected(true);
        };

        ws.current.onmessage = (event) => {
            console.log("Message received:", event.data);
            setMessages(event.data); // Append new message
        };

        ws.current.onclose = () => {
            console.log("Disconnected from WebSocket server.");
            setIsConnected(false);

            // Only reconnect if the connection was closed unexpectedly
            setTimeout(() => {
                if (!isConnected) {
                    console.log("Reconnecting to WebSocket...");
                    connectWebSocket();
                }
            }, RECONNECT_INTERVAL);
        };

        ws.current.onerror = (error) => {
            console.error("WebSocket error:", error);
        };
    };

    useEffect(() => {
        connectWebSocket();

        return () => {
            ws.current?.close();
        };
    }, []);

    return { messages, isConnected };
}
